import "../style/page/cashback.scss";
import { useEffect, useState, useMemo } from "react";
import { cashback, cashpoint } from "../../text/apidata";
import axios from "axios";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import BasicTable from "../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import noimage from "../../assets/images/noimage.png";
import { sidebar } from "../redux/reducer/counterslice";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import FileSaver from "file-saver";
import XLSX from "sheetjs-style";

export default function CashBack(props) {
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [datacount, setdatacount] = useState();
  const [data, setdata] = useState([]);
  const dispatch = useDispatch();
  const [doctorcount, setdoctorcount] = useState(0);
  const [patientcount, setpatientcount] = useState(0);
  const [appoinmentcount, setappoinmentcount] = useState(0);
  const [totaldatacount, settotaldatacount] = useState(0);
  const [downloadeddata, setdownloadeddata] = useState([]);

  const locationid = useSelector(
    (state) => state.counter.loginuser_location_id,
  );
  const [branches, setbranches] = useState(
    locationid != "all" ? locationid : "91",
  );
  const [islocationfilter, setislocationfilter] = useState([
    // { value: "All", id: "all", disabled: locationid == "all" ? false : true },
    {
      value: "CHETPET",
      id: "90",
      disabled: locationid == "90" || locationid == "all" ? false : true,
    },
    {
      value: "VELACHERY",
      id: "91",
      disabled: locationid == "91" || locationid == "all" ? false : true,
    },
    {
      value: "KOLATHUR",
      id: "92",
      disabled: locationid == "92" || locationid == "all" ? false : true,
    },
  ]);
  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(priorDate);
  // console.log(it, gt);
  const [range, setrange] = useState([it, it]);
  // console.log(range, dcount, "777777");
  useEffect(() => {
    props.loaderchange("true");
    axios({
      method: "get",
      url: cashback,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
      params: {
        date_gt: range[0],
        date_lt: range[1],
        page: dtpageindex,
        page_size: dtpagesize,
        phonenumber: searchQuery == "" ? null : searchQuery,
        count: "True",
        branch: branches,
      },
    })
      .then((res) => {
        console.log(res.data.data.data_all, "index7687");
        setdata(res.data.data);
        settableheaderdata(res.data.data.data_all);
        setdatacount(res.data.data_count);
        setdoctorcount(res.data.data.count);
        settotaldatacount(res.data.data.total_amount);
        setpatientcount(res.data.data.earned);
        setappoinmentcount(res.data.data.redeemed);
        props.loaderchange("false");
      })
      .catch((error) => {
        console.log(error);
        props.loaderchange("false");
        // setdtPageindex(dtpageindex-1)
        props.popupalert("true");
        props.popuptext("No Data Available");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      });
  }, [range, dtpageindex, dtpagesize, searchQuery, branches]);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const handlechangedate = (name, value) => {
    // let data =value.slice(0, 10)
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };
  const cleaningrange = () => {
    //setrange([gt,it]);
  };
  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },

    {
      label: "Last week",
      closeOverlay: false,
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      appearance: "default",
    },
    {
      label: "Next week",
      closeOverlay: false,
      value: (value, index) => {
        // console.log(value);
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
        ];
      },
      appearance: "default",
    },
  ];
  const columns = useMemo(
    () => [
      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_date;
          const dateObject = new Date(dateString);

          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12; // 0 should be converted to 12

          const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${formattedTime}`}
              >
                {`${
                  row.row.original.created_date.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </p>
            </>
          );
        },
      },

      {
        Header: "Bill ID",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p>
                <span>
                  {row.row.original.order_appointment != null
                    ? row.row.original.order_appointment?.appointmentbookrazorpay?.id?.split(
                        "-",
                      )[4]
                    : row.row.original.diagnostics_op_payment != null
                      ? row.row.original.diagnostics_op_payment?.bill_id
                      : row.row.original.order_pharmacy != null
                        ? row.row.original.order_pharmacy?.ordercreaterazorpay?.id.split(
                            "-",
                          )[4]
                        : row.row.original.billpaymentip != null
                          ? row.row.original.billpaymentip.bill_id
                          : row.row.original.order_diagnostics != null
                            ? row.row.original.order_diagnostics?.razorpay_diagnostics?.id?.split(
                                "-",
                              )[4]
                            : row.row.original.pharmacy_op_payment != null
                              ? row.row.original.pharmacy_op_payment.bill_id
                              : "--"}
                </span>
              </p>
            </>
          );
        },
      },
      {
        Header: "Patient Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                {row.row.original.order_appointment != null
                  ? row.row.original.order_appointment.patient.first_name +
                    row.row.original.order_appointment.patient.last_name
                  : row.row.original.diagnostics_op_payment != null
                    ? row.row.original.diagnostics_op_payment.paid_to_name
                    : row.row.original.order_pharmacy != null
                      ? row.row.original.order_pharmacy.patient.first_name +
                        row.row.original.order_pharmacy.patient.last_name
                      : row.row.original.billpaymentip != null
                        ? row.row.original.billpaymentip.paid_to_name
                        : row.row.original.order_diagnostics != null
                          ? row.row.original.order_diagnostics.patient
                              .first_name +
                            row.row.original.order_diagnostics.patient.last_name
                          : row.row.original.pharmacy_op_payment != null
                            ? row.row.original.pharmacy_op_payment.paid_to_name
                            : "--"}
              </span>
            </>
          );
        },
      },
      {
        Header: "Patient UHID",
        accessor: "",
        Cell: (row) => {
          const patientUHID = row.row.original.patient.p_uhid;
          return (
            <>
              <p
              // data-tooltip-id="my-tooltip"
              // data-tooltip-content={row.row.original.patient.p_uhid}
              >
                {patientUHID !== null && patientUHID !== undefined
                  ? patientUHID
                  : "--"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Encounter No",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          const encounterId =
            row.row.original.order_appointment != null
              ? row.row.original.order_appointment.encounter_id
              : row.row.original.diagnostics_op_payment != null
                ? row.row.original.diagnostics_op_payment.encounter_id
                : row.row.original.order_pharmacy != null
                  ? row.row.original.order_pharmacy.patient.encounter_id
                  : row.row.original.billpaymentip != null
                    ? row.row.original.billpaymentip.encounter_id
                    : row.row.original.order_diagnostics != null
                      ? row.row.original.order_diagnostics.patient.encounter_id
                      : row.row.original.pharmacy_op_payment != null
                        ? row.row.original.pharmacy_op_payment.encounter_id
                        : null; // Assuming a default value if all conditions fail
          return (
            <>
              {/* <span>{row.row.original.order_appointment != null ? row.row.original.order_appointment.encounter_id : row.row.original.diagnostics_op_payment != null ? row.row.original.diagnostics_op_payment.encounter_id : row.row.original.order_pharmacy != null ? row.row.original.order_pharmacy.patient.encounter_id : row.row.original.billpaymentip != null ? row.row.original.billpaymentip.encounter_id : row.row.original.order_diagnostics != null ? row.row.original.order_diagnostics.patient.encounter_id : row.row.original.pharmacy_op_payment != null ? row.row.original.pharmacy_op_payment.encounter_id : "--"}</span> */}
              <span>
                {encounterId !== null && encounterId !== undefined
                  ? encounterId
                  : "--"}
              </span>
            </>
          );
        },
      },
      {
        Header: "Payer Name",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.patient.first_name +
                  row.row.original.patient.last_name
                }
              >
                {row.row.original.patient.first_name +
                  row.row.original.patient.last_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "Payer UHID",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                {row.row.original.order_appointment != null
                  ? row.row.original.order_appointment.patient.p_uhid
                  : row.row.original.diagnostics_op_payment != null
                    ? row.row.original.diagnostics_op_payment.uhid
                    : row.row.original.order_pharmacy != null
                      ? row.row.original.order_pharmacy.patient.p_uhid
                      : row.row.original.billpaymentip != null
                        ? row.row.original.billpaymentip.uhid
                        : row.row.original.order_diagnostics != null
                          ? row.row.original.order_diagnostics.patient.p_uhid
                          : row.row.original.pharmacy_op_payment != null
                            ? row.row.original.pharmacy_op_payment.uhid
                            : "--"}
              </span>
            </>
          );
        },
      },

      {
        Header: "Cashback Type",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span style={{ display: "flex" }}>
                {row.row.original.cashback_type}
              </span>
            </>
          );
        },
      },
      {
        Header: "Sub Location",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span style={{ display: "flex" }}>
                <span>
                  {row.row.original.order_appointment != null
                    ? "--"
                    : row.row.original.diagnostics_op_payment != null
                      ? "--"
                      : row.row.original.order_pharmacy != null
                        ? row.row.original.order_pharmacy.code
                        : row.row.original.billpaymentip != null
                          ? "--"
                          : row.row.original.order_diagnostics != null
                            ? row.row.original.order_diagnostics.code
                            : row.row.original.pharmacy_op_payment != null
                              ? row.row.original.pharmacy_op_payment.code
                              : "--"}
                </span>
              </span>
            </>
          );
        },
      },
      {
        Header: "PhoneNumber",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>{row.row.original.phonenumber}</span>
            </>
          );
        },
      },

      {
        Header: "Expiring",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>{row.row.original.expiring.slice(0, 10)}</span>
            </>
          );
        },
      },
      {
        Header: "Base Bill Amount",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              ₹
              {row.row.original.order_appointment != null
                ? row.row.original.order_appointment.appointmentbookrazorpay.appointment_amount.toFixed(
                    2,
                  )
                : row.row.original.diagnostics_op_payment != null
                  ? row.row.original.diagnostics_op_payment.base_amount.toFixed(
                      2,
                    )
                  : row.row.original.order_pharmacy != null
                    ? row.row.original.order_pharmacy.base_amount
                    : row.row.original.billpaymentip != null
                      ? row.row.original.billpaymentip.base_amount.toFixed(2)
                      : row.row.original.order_diagnostics != null
                        ? row.row.original.order_diagnostics.amount_before
                        : row.row.original.pharmacy_op_payment != null
                          ? row.row.original.pharmacy_op_payment.base_amount.toFixed(
                              2,
                            )
                          : "--"}
            </>
          );
        },
      },
      {
        Header: "Earned",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>{parseFloat(row.row.original.earned).toFixed(2)}</span>
            </>
          );
        },
      },
      {
        Header: "Redeemed",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>{parseFloat(row.row.original.redeemed).toFixed(2)}</span>
            </>
          );
        },
      },
      {
        Header: "Amount Paid",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  // data-tooltip-id="my-tooltip"
                  // data-tooltip-content={row.row.original.applicable == false ? "NO" : "YES"}
                >
                  ₹
                  {row.row.original.order_appointment != null
                    ? parseFloat(
                        row.row.original.order_appointment
                          .appointmentbookrazorpay.appointment_amount,
                      ).toFixed(2)
                    : row.row.original.diagnostics_op_payment != null
                      ? parseFloat(
                          row.row.original.diagnostics_op_payment.bill_amount,
                        ).toFixed(2)
                      : row.row.original.order_pharmacy != null
                        ? parseFloat(
                            row.row.original.order_pharmacy.total_amount,
                          ).toFixed(2)
                        : row.row.original.billpaymentip != null
                          ? parseFloat(
                              row.row.original.billpaymentip.bill_amount,
                            ).toFixed(2)
                          : row.row.original.order_diagnostics != null
                            ? parseFloat(
                                row.row.original.order_diagnostics.total_amount,
                              ).toFixed(2)
                            : row.row.original.pharmacy_op_payment != null
                              ? parseFloat(
                                  row.row.original.pharmacy_op_payment
                                    .bill_amount,
                                ).toFixed(2)
                              : "--"}
                </div>
              </span>
            </>
          );
        },
      },

      {
        Header: "Return Amount",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  // data-tooltip-id="my-tooltip"
                  // data-tooltip-content={row.row.original.applicable == false ? "NO" : "YES"}
                >
                  ₹
                  {row.row.original?.order_appointment != null
                    ? "0.00"
                    : row.row.original.diagnostics_op_payment != null
                      ? parseFloat(
                          row.row.original.diagnostics_op_payment.return_amount,
                        ).toFixed(2)
                      : row.row.original.order_pharmacy != null
                        ? parseFloat(
                            row.row.original.order_pharmacy.return_amount,
                          ).toFixed(2)
                        : row.row.original.billpaymentip != null
                          ? parseFloat(
                              row.row.original.billpaymentip.return_amount,
                            ).toFixed(2)
                          : row.row.original.order_diagnostics != null
                            ? parseFloat(
                                row.row.original.order_diagnostics
                                  .return_amount,
                              ).toFixed(2)
                            : row.row.original.pharmacy_op_payment != null
                              ? parseFloat(
                                  row.row.original.pharmacy_op_payment
                                    .return_amount,
                                ).toFixed(2)
                              : "--"}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Razorpay Order ID",
        accessor: "",
        Cell: (row) => {
          const orderID =
            row.row.original.order_appointment != null
              ? row.row.original.order_appointment?.appointmentbookrazorpay
                  ?.appointment_order_id
              : row.row.original.diagnostics_op_payment != null
                ? row.row.original?.diagnostics_op_payment?.payment_order_id
                : row.row.original.order_pharmacy != null
                  ? row.row.original.order_pharmacy?.ordercreaterazorpay
                      ?.pharmacy_order_id
                  : row.row.original.billpaymentip != null
                    ? row.row.original?.billpaymentip?.payment_order_id
                    : row.row.original.order_diagnostics != null
                      ? row.row.original.order_diagnostics?.razorpay_diagnostics
                          ?.diagnostic_order_id
                      : row.row.original.pharmacy_op_payment != null
                        ? row.row.original?.pharmacy_op_payment
                            ?.payment_order_id
                        : null; // Assuming a default value if all conditions fail
          return (
            <>
              {/* <span>{row.row.original.order_appointment != null ? row.row.original.order_appointment.appointmentbookrazorpay.appointment_order_id : row.row.original.diagnostics_op_payment != null ? row.row.original.diagnostics_op_payment.payment_order_id : row.row.original.order_pharmacy != null ? row.row.original.order_pharmacy.ordercreaterazorpay.pharmacy_order_id : row.row.original.billpaymentip != null ? row.row.original.billpaymentip.payment_order_id : row.row.original.order_diagnostics != null ? row.row.original.order_diagnostics.razorpay_diagnostics.diagnostic_order_id : row.row.original.pharmacy_op_payment != null ? row.row.original.pharmacy_op_payment.payment_order_id : "--"}</span> */}
              <span>
                {orderID !== null && orderID !== undefined ? orderID : "--"}
              </span>
            </>
          );
        },
      },
      // {
      //   Header: "Razorpay ID",
      //   accessor: "",
      //   Cell: (row) => {
      //     // console.log(row.row.original.username)
      //     return (
      //       <>
      //         <span>{row.row.original.order_appointment != null ? row.row.original.order_appointment.appointmentbookrazorpay.razorpay_payment_id : row.row.original.diagnostics_op_payment != null ? row.row.original.diagnostics_op_payment.razorpay_payment_id : row.row.original.order_pharmacy != null ? row.row.original.order_pharmacy.ordercreaterazorpay.razorpay_payment_id : row.row.original.billpaymentip != null ? row.row.original.billpaymentip.razorpay_payment_id : row.row.original.order_diagnostics != null ? row.row.original.order_diagnostics.razorpay_diagnostics.razorpay_payment_id : row.row.original.pharmacy_op_payment != null ? row.row.original.pharmacy_op_payment.razorpay_payment_id : "--"}</span>
      //       </>
      //     );
      //   },
      // },
      {
        Header: "Applicable",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={
                    row.row.original.applicable == false ? "NO" : "YES"
                  }
                >
                  {row.row.original.applicable == false ? "NO" : "YES"}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Paid",
        accessor: "",
        Cell: (row) => {
          const isPaid =
            row.row.original.order_appointment != null
              ? row.row.original.order_appointment?.appointmentbookrazorpay
                  ?.isPaid
              : row.row.original.diagnostics_op_payment != null
                ? row.row.original.diagnostics_op_payment.isPaid
                : row.row.original.order_pharmacy != null
                  ? row.row.original.order_pharmacy?.ordercreaterazorpay?.isPaid
                  : row.row.original.billpaymentip != null
                    ? row.row.original.billpaymentip.isPaid
                    : row.row.original.order_diagnostics != null
                      ? row.row.original.order_diagnostics?.razorpay_diagnostics
                          ?.isPaid
                      : row.row.original.pharmacy_op_payment != null
                        ? row.row.original.pharmacy_op_payment.isPaid
                        : false; // Assuming a default value if all conditions fail
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={
                    row.row.original.applicable == false ? "NO" : "YES"
                  }
                >
                  {/* {row.row.original.order_appointment != null ? row.row.original.order_appointment.isPaid : row.row.original.diagnostics_op_payment != null ? row.row.original.diagnostics_op_payment.isPaid : row.row.original.order_pharmacy != null ? row.row.original.order_pharmacy.isPaid : row.row.original.billpaymentip != null ? row.row.original.billpaymentip.isPaid : row.row.original.order_diagnostics != null ? row.row.original.order_diagnostics.isPaid : row.row.original.pharmacy_op_payment != null ? row.row.original.pharmacy_op_payment.isPaid : "--"} */}
                  {isPaid ? "Yes" : "No"}
                </div>
              </span>
            </>
          );
        },
      },
    ],
    [],
  );
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const toIndianCurrency = (num) => {
    const curr = num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
    return curr;
  };

  const datadownload = () => {
    props.loaderchange("true");
    axios({
      method: "get",
      url: cashback,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
      params: {
        date_gt: range[0],
        date_lt: range[1],
        page: dtpageindex,
        page_size: datacount,
        phonenumber: searchQuery == "" ? null : searchQuery,
        count: "True",
        branch: branches,
      },
    })
      .then((res) => {
        props.loaderchange("true");

        console.log(res, "index7687");
        var downdata = [];
        downdata = res.data.data.data_all.map((ele, index) => {
          console.log(res.data.data.data_all, index + 1, "jdajsdhk");
          const isPaid =
            ele.order_appointment != null
              ? ele.order_appointment.isPaid
              : ele.diagnostics_op_payment != null
                ? ele.diagnostics_op_payment.isPaid
                : ele.order_pharmacy != null
                  ? ele.order_pharmacy.isPaid
                  : ele.billpaymentip != null
                    ? ele.billpaymentip.isPaid
                    : ele.order_diagnostics != null
                      ? ele.order_diagnostics.isPaid
                      : ele.pharmacy_op_payment != null
                        ? ele.pharmacy_op_payment.isPaid
                        : false; // Assuming a default value if all conditions fail

          // return {
          //   "bill_id": ele.order_appointment != null ? ele.order_appointment?.appointmentbookrazorpay?.id?.split("-")[4] : ele.diagnostics_op_payment != null ? ele.diagnostics_op_payment?.bill_id : ele.order_pharmacy != null ? ele.order_pharmacy?.ordercreaterazorpay?.id?.split("-")[4] : ele.billpaymentip != null ? ele.billpaymentip?.bill_id : ele.order_diagnostics != null ? ele.order_diagnostics?.razorpay_diagnostics?.id?.split("-")[4] : ele.pharmacy_op_payment != null ? ele.pharmacy_op_payment?.bill_id : "--",
          //   "Patient Name": ele.patient.first_name + ele.patient.last_name,
          //   "Patient UHID": ele.patient.p_uhid,
          //   "Encounter No": ele.order_appointment != null ? ele.order_appointment.encounter_id : ele.diagnostics_op_payment != null ? ele.diagnostics_op_payment.encounter_id : ele.order_pharmacy != null ? ele.order_pharmacy.patient.encounter_id : ele.billpaymentip != null ? ele.billpaymentip.encounter_id : ele.order_diagnostics != null ? ele.order_diagnostics.patient.encounter_id : ele.pharmacy_op_payment != null ? ele.pharmacy_op_payment.encounter_id : "--",
          //   "Payer Name": ele.order_appointment != null ? ele.order_appointment.patient.first_name + ele.order_appointment.patient.last_name : ele.diagnostics_op_payment != null ? ele.diagnostics_op_payment.paid_to_name : ele.order_pharmacy != null ? ele.order_pharmacy.patient.first_name + ele.order_pharmacy.patient.last_name : ele.billpaymentip != null ? ele.billpaymentip.paid_to_name : ele.order_diagnostics != null ? ele.order_diagnostics.patient.first_name + ele.order_diagnostics.patient.last_name : ele.pharmacy_op_payment != null ? ele.pharmacy_op_payment.paid_to_name : "--",
          //   "Payer UHID": ele.order_appointment != null ? ele.order_appointment.patient.p_uhid : ele.diagnostics_op_payment != null ? ele.diagnostics_op_payment.uhid : ele.order_pharmacy != null ? ele.order_pharmacy.patient.p_uhid : ele.billpaymentip != null ? ele.billpaymentip.uhid : ele.order_diagnostics != null ? ele.order_diagnostics.patient.p_uhid : ele.pharmacy_op_payment != null ? ele.pharmacy_op_payment.uhid : "--",
          //   "Cashback Type": ele.cashback_type,
          //   "Sub Location": ele.patient.branch_display,
          //   "PhoneNumber": ele.phonenumber,
          //   "Created Date": ele.created_date.slice(0, 10),
          //   "Expiring": ele.expiring.slice(0, 10),
          //   "Base Bill Amount": ele.order_appointment != null ? ele.order_appointment?.appointmentbookrazorpay?.appointment_amount.toFixed(2) : ele.diagnostics_op_payment != null ? ele.diagnostics_op_payment.base_amount.toFixed(2) : ele.order_pharmacy != null ? ele.order_pharmacy.base_amount : ele.billpaymentip != null ? ele.billpaymentip.base_amount.toFixed(2) : ele.order_diagnostics != null ? ele.order_diagnostics.amount_before : ele.pharmacy_op_payment != null ? ele.pharmacy_op_payment.base_amount.toFixed(2) : "--",
          //   "Earned": parseFloat(ele.earned).toFixed(2),
          //   "Redeemed": parseFloat(ele.redeemed).toFixed(2),
          //   "Amount Paid": ele.order_appointment != null ? ele.order_appointment?.appointmentbookrazorpay?.appointment_amount : ele.diagnostics_op_payment != null ? ele.diagnostics_op_payment.bill_amount : ele.order_pharmacy != null ? ele.order_pharmacy.total_amount : ele.billpaymentip != null ? ele.billpaymentip.bill_amount : ele.order_diagnostics != null ? ele.order_diagnostics.total_amount : ele.pharmacy_op_payment != null ? ele.pharmacy_op_payment.bill_amount : "--",
          //   "Razorpay Order ID": ele.order_appointment != null ? ele.order_appointment?.appointmentbookrazorpay?.appointment_order_id : ele.diagnostics_op_payment != null ? ele.diagnostics_op_payment?.payment_order_id : ele.order_pharmacy != null ? ele.order_pharmacy?.ordercreaterazorpay?.pharmacy_order_id : ele.billpaymentip != null ? ele.billpaymentip?.payment_order_id : ele.order_diagnostics != null ? ele.order_diagnostics?.razorpay_diagnostics?.diagnostic_order_id : ele.pharmacy_op_payment != null ? ele.pharmacy_op_payment.payment_order_id : "--",
          //   // "Razorpay ID": ele.order_appointment != null ? ele.order_appointment?.appointmentbookrazorpay?.razorpay_payment_id : ele.diagnostics_op_payment != null ? ele.diagnostics_op_payment.razorpay_payment_id : ele.order_pharmacy != null ? ele.order_pharmacy.ordercreaterazorpay.razorpay_payment_id : ele.billpaymentip != null ? ele.billpaymentip.razorpay_payment_id : ele.order_diagnostics != null ? ele.order_diagnostics.razorpay_diagnostics.razorpay_payment_id : ele.pharmacy_op_payment != null ? ele.pharmacy_op_payment.razorpay_payment_id : "--",
          //   "Applicable": ele.applicable == false ? "NO" : "YES",
          //   "Paid": isPaid ? "Yes" : "No"
          // }

          return {
            bill_id:
              ele.order_appointment != null
                ? ele.order_appointment?.appointmentbookrazorpay?.id?.split(
                    "-",
                  )[4]
                : ele.diagnostics_op_payment != null
                  ? ele.diagnostics_op_payment?.bill_id
                  : ele.order_pharmacy != null
                    ? ele.order_pharmacy?.ordercreaterazorpay?.id?.split("-")[4]
                    : ele.billpaymentip != null
                      ? ele.billpaymentip?.bill_id
                      : ele.order_diagnostics != null
                        ? ele.order_diagnostics?.razorpay_diagnostics?.id?.split(
                            "-",
                          )[4]
                        : ele.pharmacy_op_payment != null
                          ? ele.pharmacy_op_payment?.bill_id
                          : "--",
            "Patient Name": ele.patient.first_name + ele.patient.last_name,
            "Patient UHID": ele.patient.p_uhid,
            "Encounter No":
              ele.order_appointment != null
                ? ele.order_appointment.encounter_id
                : ele.diagnostics_op_payment != null
                  ? ele.diagnostics_op_payment.encounter_id
                  : ele.order_pharmacy != null
                    ? ele.order_pharmacy.patient.encounter_id
                    : ele.billpaymentip != null
                      ? ele.billpaymentip.encounter_id
                      : ele.order_diagnostics != null
                        ? ele.order_diagnostics.patient.encounter_id
                        : ele.pharmacy_op_payment != null
                          ? ele.pharmacy_op_payment.encounter_id
                          : "--",
            "Payer Name":
              ele.order_appointment != null
                ? ele.order_appointment.patient.first_name +
                  ele.order_appointment.patient.last_name
                : ele.diagnostics_op_payment != null
                  ? ele.diagnostics_op_payment.paid_to_name
                  : ele.order_pharmacy != null
                    ? ele.order_pharmacy.patient.first_name +
                      ele.order_pharmacy.patient.last_name
                    : ele.billpaymentip != null
                      ? ele.billpaymentip.paid_to_name
                      : ele.order_diagnostics != null
                        ? ele.order_diagnostics.patient.first_name +
                          ele.order_diagnostics.patient.last_name
                        : ele.pharmacy_op_payment != null
                          ? ele.pharmacy_op_payment.paid_to_name
                          : "--",
            "Payer UHID":
              ele.order_appointment != null
                ? ele.order_appointment.patient.p_uhid
                : ele.diagnostics_op_payment != null
                  ? ele.diagnostics_op_payment.uhid
                  : ele.order_pharmacy != null
                    ? ele.order_pharmacy.patient.p_uhid
                    : ele.billpaymentip != null
                      ? ele.billpaymentip.uhid
                      : ele.order_diagnostics != null
                        ? ele.order_diagnostics.patient.p_uhid
                        : ele.pharmacy_op_payment != null
                          ? ele.pharmacy_op_payment.uhid
                          : "--",
            "Cashback Type": ele.cashback_type,
            "Sub Location":
              ele.order_appointment != null
                ? "--"
                : ele.diagnostics_op_payment != null
                  ? "--"
                  : ele.order_pharmacy != null
                    ? ele.order_pharmacy.code
                    : ele.billpaymentip != null
                      ? "--"
                      : ele.order_diagnostics != null
                        ? ele.order_diagnostics.code
                        : ele.pharmacy_op_payment != null
                          ? ele.pharmacy_op_payment.code
                          : "--",
            PhoneNumber: ele.phonenumber,
            "Created Date": ele.created_date.slice(0, 10),
            Expiring: ele.expiring.slice(0, 10),
            "Base Bill Amount":
              ele.order_appointment != null
                ? ele.order_appointment?.appointmentbookrazorpay?.appointment_amount.toFixed(
                    2,
                  )
                : ele.diagnostics_op_payment != null
                  ? ele.diagnostics_op_payment.base_amount.toFixed(2)
                  : ele.order_pharmacy != null
                    ? ele.order_pharmacy.base_amount
                    : ele.billpaymentip != null
                      ? ele.billpaymentip.base_amount.toFixed(2)
                      : ele.order_diagnostics != null
                        ? ele.order_diagnostics.amount_before
                        : ele.pharmacy_op_payment != null
                          ? ele.pharmacy_op_payment.base_amount.toFixed(2)
                          : "--",
            Earned: parseFloat(ele.earned).toFixed(2),
            Redeemed: parseFloat(ele.redeemed).toFixed(2),
            "Amount Paid":
              ele.order_appointment != null
                ? ele.order_appointment?.appointmentbookrazorpay
                    ?.appointment_amount
                : ele.diagnostics_op_payment != null
                  ? ele.diagnostics_op_payment.bill_amount
                  : ele.order_pharmacy != null
                    ? ele.order_pharmacy.total_amount
                    : ele.billpaymentip != null
                      ? ele.billpaymentip.bill_amount
                      : ele.order_diagnostics != null
                        ? ele.order_diagnostics.total_amount
                        : ele.pharmacy_op_payment != null
                          ? ele.pharmacy_op_payment.bill_amount
                          : "--",
            "Return Amount":
              ele.order_appointment != null
                ? 0.0
                : ele.diagnostics_op_payment != null
                  ? ele.diagnostics_op_payment.return_amount
                  : ele.order_pharmacy != null
                    ? ele.order_pharmacy.return_amount
                    : ele.billpaymentip != null
                      ? ele.billpaymentip.return_amount
                      : ele.order_diagnostics != null
                        ? ele.order_diagnostics.return_amount
                        : ele.pharmacy_op_payment != null
                          ? ele.pharmacy_op_payment.return_amount
                          : "--",

            "Razorpay Order ID":
              ele.order_appointment != null
                ? ele.order_appointment?.appointmentbookrazorpay
                    ?.appointment_order_id
                : ele.diagnostics_op_payment != null
                  ? ele.diagnostics_op_payment?.payment_order_id
                  : ele.order_pharmacy != null
                    ? ele.order_pharmacy?.ordercreaterazorpay?.pharmacy_order_id
                    : ele.billpaymentip != null
                      ? ele.billpaymentip?.payment_order_id
                      : ele.order_diagnostics != null
                        ? ele.order_diagnostics?.razorpay_diagnostics
                            ?.diagnostic_order_id
                        : ele.pharmacy_op_payment != null
                          ? ele.pharmacy_op_payment.payment_order_id
                          : "--",
            // "Razorpay ID": ele.order_appointment != null ? ele.order_appointment?.appointmentbookrazorpay?.razorpay_payment_id : ele.diagnostics_op_payment != null ? ele.diagnostics_op_payment.razorpay_payment_id : ele.order_pharmacy != null ? ele.order_pharmacy.ordercreaterazorpay.razorpay_payment_id : ele.billpaymentip != null ? ele.billpaymentip.razorpay_payment_id : ele.order_diagnostics != null ? ele.order_diagnostics.razorpay_diagnostics.razorpay_payment_id : ele.pharmacy_op_payment != null ? ele.pharmacy_op_payment.razorpay_payment_id : "--",
            Applicable: ele.applicable == false ? "NO" : "YES",
            Paid: isPaid ? "Yes" : "No",
          };
        });
        let basebill = 0;
        let earned = 0;
        let redeemed = 0;
        let amountpaid = 0;

        downdata.forEach((item) => {
          amountpaid += parseFloat(item["Amount Paid"]) || 0;
          basebill += parseFloat(item["Base Bill Amount"]) || 0;
          earned += parseFloat(item["Earned"]) || 0;
          redeemed += parseFloat(item["Redeemed"]) || 0;

          // round after loop / when displaying
          amountpaid = Number(amountpaid.toFixed(2));
          basebill = Number(basebill.toFixed(2));
          earned = Number(earned.toFixed(2));
          redeemed = Number(redeemed.toFixed(2));
        });
        downdata.push({
          bill_id: "Total Sum Amount",
          "  ": "",
          "  ": "",
          "  ": "",
          "  ": "",
          "  ": "",
          "  ": "",
          "  ": "",
          "  ": "",
          "  ": "",
          "  ": "",
          "  ": "",
          // "Base Bill Amount": basebill,
          Earned: Number(res?.data?.data?.earned.toFixed(2)),
          Redeemed: Number(res?.data?.data?.redeemed.toFixed(2)),
          "Amount Paid": Number(res?.data?.data?.total_amount.toFixed(2)),
          "  ": "",
          "  ": "",
          "  ": "",
        });

        console.log(downdata, "afhajj");
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8";
        const fileExtension = ".xlsx";
        const ws = XLSX.utils.json_to_sheet(downdata);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, "CaskBack" + fileExtension);

        props.loaderchange("false");
      })
      .catch((error) => {
        console.log(error);
        props.loaderchange("false");
        props.popupalert("true");
        props.popuptext("No Data Available");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      });
  };

  return (
    <>
      <div className={sideactive ? "dashboard-main-sa" : "dashboard-main"}>
        <div class="page-header">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Cash Back Points</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Cash Back Points</li>
              </ul>
            </div>
            <div class="col-sm-5 col-auto">
              {" "}
              <div className="datepicker_dash">
                <DateRangePicker
                  defaultValue={[new Date(), new Date()]}
                  disabledDate={(date) => isAfter(date, new Date())}
                  editable={false}
                  appearance="default"
                  placement="bottomEnd"
                  size="lg"
                  ranges={predefinedBottomRanges}
                  placeholder="From - To"
                  style={{ width: 270, padding: 10, float: "right" }}
                  onClean={(e) => cleaningrange(e)}
                  onChange={(e) => {
                    if (e != null) {
                      setrange([]);
                      e.forEach((newValue) => {
                        var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                        var localISOTime = new Date(newValue - tzoffset)
                          .toISOString()
                          .slice(0, -1);
                        handlechangedate("validtill", localISOTime);
                      });
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="card">
            <div className="card-body" style={{ padding: "1.5rem" }}>
              <form
                onSubmit={handleSubmit}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div
                  class="input-group rounded"
                  style={{ width: "250px", height: "40px" }}
                >
                  <input
                    type="search"
                    class="form-control rounded"
                    aria-label="Search"
                    aria-describedby="search-addon"
                    value={searchQuery}
                    onKeyDown={(e) => {
                      if (e.target.value.length === 0 && e.which === 32) {
                        e.preventDefault();
                      }
                    }}
                    onInput={(e) => {
                      if (e.target.value.length <= "100") {
                        setSearchQuery(e.target.value);
                      } else {
                        e.preventDefault();
                      }
                    }}
                    min="0"
                    max="10"
                    label="Search"
                    placeholder="Search..."
                    required
                  />
                  <span
                    class="input-group-text border-0 bg-transparent"
                    id="search-addon"
                  >
                    <i
                      class="bi bi-search"
                      style={{
                        color: "#1b5a90",
                        width: "20px",
                        height: "20px",
                      }}
                    ></i>
                  </span>
                </div>
                <div align="center" type="button">
                  <a
                    class="dnbtn"
                    onClick={(e) => {
                      datadownload();
                    }}
                  ></a>
                </div>
              </form>

              <div className="row  m-2">
                <div className="col-xl-4 col-sm-6 col-12 ">
                  <div class="card">
                    <div class="card-body" style={{ padding: "1.5rem" }}>
                      <div class="dash-widget-header">
                        <span class="dash-widget-icon text-primary border-primary">
                          <i class="bi bi-stack"></i>
                        </span>
                        <div class="dash-count">
                          <h3>{datacount}</h3>
                        </div>
                      </div>
                      <div class="dash-widget-info">
                        <h6 class="text-muted">Count</h6>
                        <div class="progress progress-sm">
                          <div
                            class="progress-bar bg-primary"
                            role="progressbar"
                            style={{ width: `${datacount / 10}px` }}
                            aria-valuenow={datacount}
                            aria-valuemin="0"
                            aria-valuemax="100%"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-sm-6 col-12 ">
                  <div class="card">
                    <div class="card-body" style={{ padding: "1.5rem" }}>
                      <div class="dash-widget-header">
                        <span class="dash-widget-icon text-success">
                          {/* <i class="bi bi-person-bounding-box"></i> */}
                          <i class="bi bi-stars"></i>
                        </span>
                        <div class="dash-count">
                          <h3>{toIndianCurrency(patientcount)}</h3>
                          {/* <h3>{pcount}</h3> */}
                        </div>
                      </div>
                      <div class="dash-widget-info">
                        <h6 class="text-muted">Earned</h6>
                        <div class="progress progress-sm">
                          <div
                            class="progress-bar bg-success"
                            style={{ width: `${patientcount / 10}px` }}
                            aria-valuenow={patientcount}
                            aria-valuemin="0"
                            aria-valuemax="100%"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-sm-6 col-12 ">
                  <div class="card">
                    <div class="card-body" style={{ padding: "1.5rem" }}>
                      <div class="dash-widget-header">
                        <span class="dash-widget-icon text-danger border-danger">
                          {/* <i class="bi bi-person-vcard-fill"></i> */}
                          <i class="bi bi-star-fill"></i>
                        </span>
                        <div class="dash-count">
                          <h3>{toIndianCurrency(appoinmentcount)}</h3>
                        </div>
                      </div>
                      <div class="dash-widget-info">
                        <h6 class="text-muted">Redeemed</h6>
                        <div class="progress progress-sm">
                          <div
                            class="progress-bar bg-danger"
                            style={{ width: `${appoinmentcount / 10}px` }}
                            aria-valuenow={appoinmentcount}
                            aria-valuemin="0"
                            aria-valuemax="100%"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-sm-6 col-12 ">
                  <div class="card">
                    <div class="card-body" style={{ padding: "1.5rem" }}>
                      <div class="dash-widget-header">
                        <span class="dash-widget-icon text-info border-info">
                          <i class="bi bi-cash-stack"></i>
                        </span>
                        <div class="dash-count">
                          <h3>{toIndianCurrency(totaldatacount)}</h3>
                        </div>
                      </div>
                      <div class="dash-widget-info">
                        <h6 class="text-muted">Total Amount Paid</h6>
                        <div class="progress progress-sm">
                          <div
                            class="progress-bar bg-info"
                            role="progressbar"
                            style={{ width: `${totaldatacount / 10}px` }}
                            aria-valuenow={totaldatacount}
                            aria-valuemin="0"
                            aria-valuemax="100%"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <div className="row">
                  <div className="col-3">
                    <div className="w-100 rounded d-flex">
                      <label
                        class="form-label mb-0 align-self-center mr-2"
                        style={{ width: "100px" }}
                      >
                        Branch
                      </label>

                      <select
                        class="form-select w-9 0"
                        id="validationCustom04"
                        value={branches}
                        name="IsActive"
                        onChange={(e) => {
                          setbranches(e.target.value);
                        }}
                        required
                      >
                        <option value={""} selected disabled>
                          Filter By Location...
                        </option>
                        {islocationfilter.map((data) => {
                          return (
                            <>
                              {!data.disabled ? (
                                <option
                                  value={data.id}
                                  disabled={data.disabled}
                                >
                                  {data.value}
                                </option>
                              ) : (
                                ""
                              )}
                            </>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                <BasicTable
                  columns={columns}
                  data={tableheaderdata}
                  pagesize={pagesize}
                  pageindex={pageindex}
                  dtpagesize={dtpagesize}
                  dtpageindex={dtpageindex}
                  datacount={datacount}
                  // location={"others"}
                  // setbranches={setbranches}
                  // branches={branches}
                />
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={50}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
    </>
  );
}
